import { CmsReactComponent } from 'components/cms/CmsReactComponent';
import {
    PropertyDefinition, PropertyMappingType,
} from "app/library/layout-builder";
import { AccountEmailProps } from "./types";

export class AccountEmailDefinitions extends CmsReactComponent<AccountEmailProps> {
    static defaultProps = {};

    static schemaName = "account-email";

    static propertyDefinitions: PropertyDefinition[] = [{
        name: "title",
        mapping: {
            type: PropertyMappingType.String,
        },
        text: "Başlık",
    },
    {
        name: "description",
        mapping: {
            type: PropertyMappingType.Textarea,
        },
        text: "Açıklama",
    },];
}
